/* eslint-disable no-console, import/prefer-default-export */
import axios from 'axios';

const instance = axios.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Makes a GET request for the provided path and query params.
 *
 * @param {String} path for the request
 * @param {Object} params to provide in request
 * @return {Object} response data
 */
export async function get(path, params = {}) {
  try {
    const response = await instance.get(path, { params });
    return response.data;
  } catch (error) {
    if (error && error.response) {
      switch (error.response.status) {
        case 503:
          console.error(`ERROR: Service down for path: ${path}.`);
          break;
        case 500:
          console.error(`ERROR: Internal server error for path: ${path}.`);
          break;
        case 404:
          console.error(`ERROR: Not able to access path: ${path}.`);
          break;
        default:
          console.error(`ERROR: Unable to handle response: ${path}.`);
          break;
      }
    } else if (error && error.request) {
      console.error(`ERROR: No response received for ${path}.`);
    } else {
      console.error(`ERROR: ${path}`);
    }

    return null;
  }
}
